  export enum ACTION_MODE {
    NONE='none',
    ADD = 'add',
    EDIT = 'edit',
    VIEW='view',
    LIST='list',
    DELETE='delete'
  }
  export enum USER_ROLE {
    NONE='none',
    SUPER_ADMIN = 'Super Admin',
    ADMIN = 'Admin',
  }
  

  export enum DISPLAY_MODE {
    LIST_VIEW=1,
    CARD_VIEW=2,
    BROWSER_VIEW=3
  }
  
  export enum GENDER {
    Male = 'Male',
    Female = 'Female',
    Other = 'Other'
  }

  export enum PLATFORM {
    Android = 'android',
    IOS = 'ios'
  }

  export enum USER_TYPE{
    OWNER='owner',
    BOTH='both'
  }

  export enum STATUS{
    SPOIL='Spoil',
    TERMINATE='Terminate',
    WARRANTY='Warranty',
  }

  export enum IMAGE_TYPES{
    APP_LOGO,
    WEB_APP_LOGIN,
    WEB_APP_HEADER,
    IOS_CERTIFICATE,
    IOS_KEY
  }

  export enum LICENCE_TYPE{
    PLATFORM_SIM='Platform + Sim',
    PLATFORM='Platform',
  }

  export enum LICENCE_RENEWAL_TYPE{
    YEARLY='Yearly',
    MONTHLY='Monthly',
  }

  export enum ASSIGN_DEVICE_TYPE {
    NONE='',
    AGENT='agent',
    DISTRIBUTOR='distributor',
    RETAILER='retailer',
    LICENCE='licence',
    AGENT_RETAILER='agent_retailer'
  }
  
  export enum TEL_COMPANY_TYPE{
    DIGI='DIGI',
    FLEXIROAM='FLEXIROAM',
    IDEA='IDEA',
    MAXIS='MAXIS',
    MYEVO='MYEVO',
    SINTEL='SINTEL',
    TELKOMSEL='TELKOMSEL',
    VODAFONE='VODAFONE',
    XPAX='XPAX',
  }
  

  



